import { httpRequest } from '@common/util/api-common.util';

export default class LaminaApi {
  static adicionarLaminaCongelacao(laminaRequest) {
    return httpRequest('congelacao', 'POST', laminaRequest);
  }
  static editarLaminaCongelacao(laminaRequest) {
    return httpRequest('congelacao', 'PUT', laminaRequest);
  }

  static apagarLaminaCongelacao(cdLaudo, cdLaudoLamina, justificativaText) {
    return httpRequest(
      `congelacao/laudo/${cdLaudo}/lamina-congelacao/${cdLaudoLamina}`,
      'DELETE',
      { justificativa: justificativaText }
    );
  }
  static apagarBlocoCongelacao(cdLaudo, idLaudoBloco, justificativaText) {
    return httpRequest(
      `congelacao/laudo/${cdLaudo}/bloco/${idLaudoBloco}`,
      'DELETE',
      { justificativa: justificativaText }
    );
  }
  static apagarComplemento(id) {
    return httpRequest(`ComplementoEtapas`, 'DELETE', {
      idComplemento: id,
      etapa: 'congelacao',
    });
  }

  static getListagemLaminas(laudo) {
    return httpRequest(`congelacao/${laudo}`).then((json) => json.data);
  }

  static obterInfoLaudoNovaLaminaCongelacao(nrExame) {
    return httpRequest(`congelacao/nr-exame/${nrExame}`);
  }

  static obterVentana(nrExame) {
    return httpRequest(`lamina/ventana/${nrExame}`);
  }
  static enviarLaminaVentana(laminaRequest) {
    return httpRequest('lamina/ventana', 'POST', laminaRequest);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/lamina/lamina.api.js